import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProjectMember } from '../../../../models/project/project-info.model';
import { UserpilotReloader } from '../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-members',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.scss']
})
export class MemberComponent extends UserpilotReloader implements OnInit {
  member = new ProjectMember();
  isEdit = false;

  constructor(
    public dialogRef: MatDialogRef<MemberComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { member: ProjectMember }
  ) {
    super();
  }

  ngOnInit() {
    if (this.data.member) {
      this.member = this.data.member;
      this.isEdit = true;
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onMemberOKClick() {
    if (this.member.name) {
      this.dialogRef.close(this.member);
      return;
    }
    this.dialogRef.close();
  }
}
